<template>
    <div class="com-famous-comment-item-web dsp-flex">
        <div class="com-famous-ci-avatar">
            <img class="com-famous-ci-img" v-bind:src="itemData.userAvatar == '' ? avatarUrl : itemData.userAvatar" alt="">
        </div>
        <div class="com-famous-ci-content">
            <div class="com-famous-cic-title">
                <span class="com-famous-cic-nickname">{{itemData.userName}} <span v-if="itemData.toName" class="com-famous-cis-reply">回</span> <span v-if="itemData.toName">{{itemData.toName}}</span></span>
                <span v-if="!itemData.isDelete" class="com-famous-cic-more" @click="clickMore">
                    <i class="iconfont icon-more"></i>
                </span>
            </div>
            <div class="layout-overlay layout-overlay-blank" v-if="showOperate" @click="clickBlankOverlay"></div>
            <div class="com-famous-operate-pop" v-if="showOperate">
                <div class="famous-crl-item" v-if="curCommentMoreFromMe" @click="clickDelete">删除</div>
                <div class="famous-crl-item" v-else @click="clickReport">举报</div>
            </div>
            <div v-if="itemData.isDelete" class="com-famous-cic-content-delete">
                <p>该评论已删除</p>
            </div>
            <div v-else class="com-famous-cic-content" @click.stop="clickCommentItem">
                <p v-html="UTILS.getBreakLineByText(itemData.msg)"></p>
            </div>
            <div class="com-famous-cic-sub">
                <span v-if="!itemData.isDelete" class="com-famous-cic-good-2" @click.passive="clickLike">
                    <i class="iconfont" v-bind:class="{'icon-good2':itemData.isLike == 1, 'icon-good3':itemData.isLike == 0}"></i>赞<span v-if="itemData.likeNum != 0" class="com-famous-cic-good-num">{{itemData.likeNum}}</span>
                </span>
                <span v-if="!itemData.isDelete" class="com-famous-cic-comment" @click="clickReply">
                    <i class="iconfont icon-comment-1"></i>回复
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { UTILS } from '../../modules/utils'
export default {
    name: 'FamousCommentItemWeb',
    computed: {
        curCommentMoreFromMe() {
            return this.$store.state.famouspediacomment.curCommentMoreFromMe;
        }
    },
    props: {
        itemData: {
            type: Object,
            default() { return {} }
        },
        itemFunc: {
            type: Function,
            default() { return null }
        },
        operateFunc: {
            type: Function,
            default() { return null }
        }
    },
    data() {
        return {
            UTILS: UTILS,
            avatarUrl: require('../../assets/images/avatar.png'),
            showOperate: false
        }
    },
    methods: {
        clickCommentItem() {
            if(this.itemFunc && typeof(this.itemFunc) == 'function') {
                this.itemFunc()
            }
        },
        clickMore() {
            var me = this;
            var userData = this.$store.state.userData;
                userData = userData && userData.info ? userData.info : {};
            this.$store.dispatch('weblogin/checkWebLogin', {
                sucCb: function() {
                    me.$store.dispatch('famouspediacomment/initCommentAllListMore', {
                        data: me.itemData,
                        userData: userData
                    });
                    me.showOperate = true;
                }
            });            
        },
        clickLike() {
            var me = this;
            this.$store.dispatch('weblogin/checkWebLogin', {
                sucCb: function() {
                    if(me.operateFunc && typeof(me.operateFunc) == 'function') {
                        me.operateFunc('like', me.itemData)
                    }
                }
            });
        },
        clickReply() {
            var me = this;
            this.$store.dispatch('weblogin/checkWebLogin', {
                sucCb: function() {
                    if(me.operateFunc && typeof(me.operateFunc) == 'function') {
                        me.operateFunc('reply', me.itemData)
                    }
                }
            });
        },
        clickBlankOverlay() {
            this.showOperate = false;
        },
        clickDelete() {
            var me = this;
            this.$store.dispatch('famouspediacomment/deleteComment', {
                cb: function() {
                    me.$toast('删除评论成功');
                },
                failCb: function() {
                    me.$toast('删除评论失败');
                }
            });
        },
        clickReport() {
            var userData = this.$store.state.userData;
                userData = userData && userData.info ? userData.info : {};
            this.$store.dispatch('famouspediacomment/initCommentAllListMore', {
                data: this.itemData,
                userData: userData
            });
            this.$store.state.weblogin.showWebReport = true;
        },
    }
}
</script>